import { ContainerPrice } from "./container-price.model";

export class ContainerPriceMapper {
  static map(data: any): ContainerPrice {
    return new ContainerPrice(data.name, data.value);
  }
}
